"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLogo = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("assets/styles/config");
exports.StyledLogo = styled_components_1.default.img `
  margin-left: 10px;
  height: auto;
  width: 80%;

  @media ${config_1.device.laptop} {
    width: 50%;
  }
`;
